import { Injectable } from '@angular/core';
import { AbstractHttpService } from 'src/app/commons/abstract-http.service';
import { HttpClient } from '@angular/common/http';
import { ResponseData } from 'src/app/model/response.data';
import { EditalDTO } from 'src/app/model/dto/edital.dto';
import { Observable } from 'rxjs/Observable';

@Injectable({
  providedIn: 'root'
})
export class EditalService extends AbstractHttpService {

  private ENDPOINT_EDITAL_CADASTRAR = 'edital'
  private EDITAL = 'edital';
  private BLOQUEAR = 'bloquear';
  private ATUALIZAR= 'atualizar';
  private INSCRITOS= 'inscritos';
  private ATIVOS= 'ativos';



  constructor(http:HttpClient) {
    super(http);
  }

  buscarEdital(status: number) {
    return this.getMethod<ResponseData<EditalDTO[]>>(`${this.EDITAL}/${status}`);
  }

  buscarEditaisAtivos(status: number) {
    return this.getMethod<ResponseData<EditalDTO[]>>(`${this.EDITAL}/${this.ATIVOS}/${status}`);
  }

  cadastrarEdital(cadastrar: any): Observable<any>{
    return this.postMethod(cadastrar, this.EDITAL);
  }

  inativar(id: number): Observable<ResponseData<EditalDTO>>{
    return this.getMethod(`${this.EDITAL}/inativar/${id}`);
  }
  atualizar(atualizar: EditalDTO): Observable<ResponseData<EditalDTO>>{
    return this.postMethod(atualizar, `${this.EDITAL}/${this.ATUALIZAR}/`);
  }

  verificarInscritos(id: number) {
    return this.getMethod(`${this.EDITAL}/${this.INSCRITOS}/${id}`).toPromise();
  }

  bloquear(id: number, block: number) {
    return this.getMethod(`${this.EDITAL}/${this.BLOQUEAR}/${id}/${block}`).toPromise();
  }
}
